// extracted by mini-css-extract-plugin
export default {"recaptcha-box":"styles_recaptcha-box__ej-1P"};